"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeComponentWhitespace = exports.stripCjkSegmentBreaks = void 0;
// Migration pretty-printing wrapped long HTML lines before inline tags (`「\n <strong>`); browsers
// render such a break as a space, which is wrong inside CJK text. A break is removed only when it
// is tag-adjacent with a rendered CJK character beside it. <pre>/<code> content is skipped —
// newlines there are real — and Hangul does not count as CJK here (Korean uses spaces).
const CJK_CHAR = /[\u2E80-\u303F\u3040-\u30FF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFF00-\uFFEF]/;
const TAGS = /<[^>]*>/g;
const PREFORMATTED_OR_BREAK = /<(pre|code)\b[^>]*>[\s\S]*?<\/\1\s*>|\r?\n[ \t]*/gi;
const stripCjkSegmentBreaks = (html) => {
    if (typeof html !== 'string' || html.indexOf('\n') === -1 || !CJK_CHAR.test(html)) {
        return html;
    }
    return html.replace(PREFORMATTED_OR_BREAK, (match, preformatted, offset) => {
        if (preformatted) {
            return match;
        }
        const before = html.slice(0, offset);
        const after = html.slice(offset + match.length);
        if (!/>[ \t]*$/.test(before) && after[0] !== '<') {
            return match;
        }
        const prev = (before.replace(TAGS, '').match(/(\S)\s*$/) || [])[1] || '';
        const next = (after.replace(TAGS, '').match(/^\s*(\S)/) || [])[1] || '';
        return CJK_CHAR.test(prev) || CJK_CHAR.test(next) ? '' : match;
    });
};
exports.stripCjkSegmentBreaks = stripCjkSegmentBreaks;
const normalizeComponentWhitespace = (component) => JSON.parse(JSON.stringify(component), (key, val) => key === 'html' || key === 'renderedHtml'
    ? (0, exports.stripCjkSegmentBreaks)(val)
    : key === 'cells' && Array.isArray(val)
        ? val.map((row) => row.map(exports.stripCjkSegmentBreaks))
        : val);
exports.normalizeComponentWhitespace = normalizeComponentWhitespace;
